import { cloneElement } from 'react';
import { isArray } from 'coreutils-js';

// @ts-ignore
import { useAuth } from "@microcoreapps/authentication";
import { Outlet, Route, Navigate } from "react-router-dom";
// @ts-ignore
import { PageError } from '@microui/react-ui';

import UserProfile from "pages/user/profile";
import UserChangePassword from "pages/user/change-password";
import UserVerify from "pages/user/verify";
import TenantList from "pages/tenant/list";
import ClientList from "pages/client/list";
import ClientTenant from 'pages/client/tenant';
import TenantClient from 'pages/tenant/client';

export const ProtectedLayout = () => {
    const { user } = useAuth();

    if (!user) {
        return null;
    }

    return <Outlet />;
};

const routes = (userProfile?) => [
    {
        icon: { icon: 'account-circle', theme: 'outlined' },
        title: 'Cá nhân',
        displayOnMenu: true,
        children: [
            {
                title: 'Thông tin tài khoản',
                path: '/user/profile',
                displayOnMenu: true,
                element: <UserProfile />
            },
            {
                title: 'Đổi mật khẩu',
                path: '/user/change-password',
                displayOnMenu: true,
                element: <UserChangePassword />
            },
            userProfile?.isemailconfirmed == 0 &&
            {
                title: 'Xác thực tài khoản',
                path: '/user/verify',
                displayOnMenu: true,
                element: <UserVerify />
            },
        ].filter(Boolean)
    },
    {
        icon: { icon: 'channel', theme: 'outlined' },
        title: 'Kênh',
        path: '/tenant',
        displayOnMenu: true,
        element: <TenantList />,
        children: [
            {
                title: 'Ứng dụng của kênh',
                path: '/tenant/:id',
                displayOnMenu: false,
                element: <TenantClient />,
            }
        ],
    },
    {
        icon: { icon: 'application', theme: 'outlined' },
        title: 'Ứng dụng',
        path: '/client',
        displayOnMenu: true,
        element: <ClientList />,
        children: [
            {
                title: 'Kênh của ứng dụng',
                path: '/client/:id',
                displayOnMenu: false,
                element: <ClientTenant />,
            }
        ],
    },
];

export const renderRoutes = (userProfile?) => {
    const elements = [];

    function loadRoutes(routes, callback) {
        if (isArray(routes)) {
            routes.forEach(route => {
                if (route.path) callback(route);
                if (route.children) loadRoutes(route.children, callback);
            });
        }
    }

    loadRoutes(routes(userProfile), (route) => {
        if (route.path) {
            elements.push(
                <Route path={route.path} element={route.element || <></>} />
            );
        }
    });

    return (
        <Route element={<ProtectedLayout />}>
            <Route path="/" element={<Navigate to="/user/profile" />} />
            {elements.map(el => cloneElement(el))}
            <Route path="*" element={<PageError code="404" />} />
        </Route>
    );
}

export const getLayoutRoutes = (userProfile?) => {
    const layoutRoutes = [];

    function loadRoutes(routes, parent) {
        if (isArray(routes)) {
            routes.forEach(route => {
                parent.push({
                    icon: route.icon,
                    title: route.title,
                    path: route.path,
                    redirect: route.redirect,
                    displayOnMenu: route.displayOnMenu,
                    children: []
                });

                if (route.children) {
                    const children = parent[parent.length - 1].children;
                    loadRoutes(route.children, children);
                };
            });
        }
    }

    loadRoutes(routes(userProfile), layoutRoutes);

    return layoutRoutes;
}